module.exports = "/assets/2886e4b929e34c2fb29f547f5be059a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/A5.png
// module id = 1183
// module chunks = 0